import { render, staticRenderFns } from "./SetOverallTargetForm.vue?vue&type=template&id=32ee9f89"
import script from "./SetOverallTargetForm.vue?vue&type=script&lang=js"
export * from "./SetOverallTargetForm.vue?vue&type=script&lang=js"
import style0 from "./SetOverallTargetForm.vue?vue&type=style&index=0&id=32ee9f89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBtn,QInput,QIcon,QPopupProxy,QDate,QSkeleton});
